import { DataValidator, IsString, Required, transformKeys } from "@/utils/type-vaildator";
import api, { apiV2 } from "./api";

export class VoiceTemplateItemData {
  @Required("id is required")
  @IsString("id must be a string")
  id: string;
  @Required("sampleUrl is required")
  @IsString("sampleUrl must be a string")
  sampleUrl: string;
  @Required("name is required")
  @IsString("name must be a string")
  name: string;
  @Required("createdAt is required")
  @IsString("createdAt must be a string")
  createdAt: string;
  @Required("voiceTtsId is required")
  @IsString("voiceTtsId must be a string")
  voiceTtsId: string;
}

interface UserAudioTemplateListResponse {
  audios?: unknown[];
}


type UserAudioTemplateListRequest = {
  agentId?: string;
  page: number;
  pageSize: number;
};

export const userAudioTemplateList = async ({
  agentId = "",
  page,
  pageSize,
}: UserAudioTemplateListRequest): Promise<{
  templates: VoiceTemplateItemData[];
  total?: number;
  currentPage?: number;
  pageSize?: number;
  totalPages?: number;
}> => {
  const params: {
    page: number;
    page_size: number;
    agent_id?: string;
  } = {
    page,
    page_size: pageSize,
  }
  if (agentId) {
    params.agent_id = agentId;
  }
  const res = await apiV2.post<UserAudioTemplateListResponse>("user_audio_template/list", params);
  const list = res.data?.audios || [];
  const templates: VoiceTemplateItemData[] = list.map((item) => {
    const t = transformKeys(item);
    return DataValidator.validateOrThrow(t, VoiceTemplateItemData);
  });

  return {
    templates,
  };
};
